import { DatePicker as AntTimePicker } from "antd";

const { RangePicker } = AntTimePicker;

export const TIME_PICKER_TYPES = {
  range: RangePicker,
  time: AntTimePicker,
};
